var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLpFooterDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2788_4155)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    stroke: "#0D1615"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69014 17.1732C13.0423 18.4814 15.895 18.7362 19.1277 16.7C19.104 16.7355 18.4645 17.6829 16.7829 18.1684C17.1382 18.6539 17.6237 19.2105 17.6237 19.2105C18.7014 19.2105 19.7553 18.9026 20.6671 18.3105C21.3777 17.8368 21.7803 17.0197 21.6974 16.1671C21.5553 14.7105 21.2118 13.2894 20.679 11.9276C20.004 10.1513 18.3816 8.91973 16.4987 8.74209C16.3329 8.73024 16.2145 8.73024 16.1435 8.73024L15.954 8.9197C18.1211 9.53549 19.1987 10.4947 19.2224 10.5302C15.8948 8.84864 11.9632 8.82498 8.61186 10.4592C8.61186 10.4592 9.67766 9.40524 12.0342 8.84864L11.8921 8.70654C11.6434 8.70654 11.4066 8.73024 11.1579 8.76575C9.41711 9.0618 7.96055 10.2578 7.33291 11.9039C6.78816 13.3249 6.43291 14.817 6.30266 16.3328C6.23161 17.1381 6.61055 17.9315 7.27371 18.3934C8.15001 18.9736 9.19211 19.2815 10.2461 19.2815C10.2461 19.2815 10.6724 18.7249 11.0987 18.2276C9.50001 17.7539 8.84871 16.8065 8.83686 16.771L9.13773 16.9246C9.31759 17.0165 9.50198 17.0998 9.69014 17.1732ZM11.5487 16.1434C10.779 16.1197 10.175 15.4684 10.1987 14.6868C10.2224 13.9526 10.8145 13.3605 11.5487 13.3368C12.3185 13.3605 12.9224 14.0118 12.8987 14.7934C12.8632 15.5276 12.2829 16.1197 11.5487 16.1434ZM16.3803 16.1434C15.6105 16.1197 15.0066 15.4684 15.0303 14.6868C15.054 13.9526 15.6461 13.3605 16.3803 13.3368C17.15 13.3605 17.754 14.0118 17.7303 14.7934C17.7066 15.5276 17.1145 16.1197 16.3803 16.1434Z",
    fill: "#0D1615"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2788_4155",
    x: 0,
    y: 0,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2788_4155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2788_4155",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpFooterDiscord);
export default __webpack_public_path__ + "static/media/lp-footer-discord.91d726d2504d5d67b3ee2187b8573afa.svg";
export { ForwardRef as ReactComponent };